
export function loadEditData () {
    this.editData = this.env.getPageInfo('/admin/analytics/subscriber-data/edit/');
}

export function saveEditData () {
    this.env.setPageInfo('/admin/analytics/subscriber-data/edit/', this.editData);
}
